import { SearchX } from "lucide-react";
import { AppLink, EmptyState } from "@amber/ui";
import { AppFrame } from "../shell/AppFrame";
import { usePageTitle } from "../shell/title";

export function NotFoundPage({ lookedUp }: { lookedUp: string }) {
  usePageTitle("Not found");
  return (
    <AppFrame view="Not found">
      {() => (
        <EmptyState
          level={1}
          icon={<SearchX />}
          title="This link doesn't point to anything we know"
          actions={
            <AppLink href="/" className="inline-flex h-8 items-center px-2 font-strong text-link">
              Back to Home
            </AppLink>
          }
        >
          <p className="m-0">
            We looked up <code className="font-mono text-md break-all text-fg">{lookedUp}</code>. Check the link, or ask
            whoever shared it.
          </p>
        </EmptyState>
      )}
    </AppFrame>
  );
}
